import type { RouteObject } from 'react-router-dom'
import { useRoutes } from 'react-router-dom'
import Home from '@/pages/Home'
import Shop from '@/pages/Shop'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/shop', element: <Shop /> },
]

function App() {
  return useRoutes(routes)
}

export default App
